/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { StyleSheet, View, ActivityIndicator, Dimensions } from 'react-native';
import { addDays, format, parseISO } from 'date-fns';

import SociollaText from '@components/sociolla/SociollaText';
import {
  SociollaInput,
  SociollaSelectBox,
  SociollaDatePicker,
  SociollaMarketTypeSearch,
  SociollaCheckbox,
} from '@components/sociolla/form';
import ItemDetail from '@components/global/ItemDetail';
import Image from '@components/global/Image';

import Colors from '@global/colors';
import { isWeb, isMobileWeb } from '@global/screens';
import { generateStatus, changeTimeZone, parseDate } from '@global/helpers';

const img = require('@/assets/img/default/user-image.png');
const { height: windowHeight } = Dimensions.get('window');

const CURRENCY = [
  { value: 'IDR', name: 'Rupiah' },
  { value: 'VND', name: 'Vietnam đồng' },
];
const TAX_TYPES = [
  { value: 'inc', name: 'Include Taxes' },
  { value: 'exc', name: 'Exclude Taxes' },
];

function PricelistDetail(props) {
  const { isAddMode, isEditMode, priceRules } = props;
  const [data, setData] = useState({});
  const [dateRange, setDateRange] = useState({ to_date: '', from_date: '' });

  useEffect(() => {
    if (priceRules?.data) {
      const pr = { ...priceRules.data };
      if (pr.updated_at) {
        pr.last_updated = format(parseISO(pr.updated_at), 'dd MMM yyyy');
      }
      if (pr.from_date && pr.to_date) {
        setDateRange({ to_date: pr.to_date, from_date: pr.from_date });
        pr.effective_date =
          parseDate(pr.from_date, 'dd MMM yyyy') +
          ' - ' +
          parseDate(pr.to_date, 'dd MMM yyyy');
      }
      if (pr.status) {
        const status = generateStatus('price_rules', pr.status, 'value');
        pr.status = status.label;
        pr.statusStyle = {
          fontSize: 10,
          color: Colors.black,
          backgroundColor: status.color,
          paddingHorizontal: 15,
          paddingVertical: 7,
          borderRadius: 4,
          width: 120,
          textAlign: 'center',
          marginLeft: isWeb ? -30 : 0,
        };
      }
      pr.isActiveStyle = {
        fontSize: 10,
        color: Colors.black,
        backgroundColor: pr.is_active_auto ? '#DEF1FF' : '#EEEEEE',
        paddingHorizontal: 16,
        paddingVertical: 2,
        borderRadius: 4,
        width: 110,
        textAlign: 'center',
        marginLeft: 0,
      };
      setData(pr);
    }
  }, [priceRules]);

  const dateRangeHandler = (value, key) => {
    setDateRange({ ...dateRange, [key]: value });
  };

  const User = (userProps) => {
    return (
      <View
        style={{
          flex: 1,
          flexDirection: 'row',
          justifyContent: 'flex-start',
          ...userProps.style,
        }}
        key={'list-users-' + userProps.index}>
        <Image
          style={{ width: 20, height: 20, marginRight: 8 }}
          width={20}
          height={20}
          isResolveAsset
          source={
            Array.isArray(userProps?.image) && userProps?.image.length > 0
              ? userProps?.image[0]
              : userProps?.image !== ''
              ? userProps?.image
              : img
          }
        />
        <SociollaText
          style={{ fontSize: 12, color: Colors.blue3, alignSelf: 'center' }}>
          {userProps.name}
        </SociollaText>
      </View>
    );
  };

  return (
    <View
      style={[
        styles.formContainer,
        isMobileWeb && {
          height: windowHeight - (props.showStickyButton ? 270 : 150),
          overflow: 'auto',
        },
      ]}>
      {(isAddMode || isEditMode) && (
        <>
          <View style={styles.flexWidth}>
            <View style={styles.formMargin}>
              <SociollaInput
                label="Description"
                name="description"
                multiline={true}
                numberOfLines={2}
                isRequired
              />
            </View>
            <View style={styles.formMargin}>
              <SociollaMarketTypeSearch name="market_type" />
            </View>
            <View style={styles.formMargin}>
              <SociollaSelectBox
                label="Currency"
                options={CURRENCY}
                name="currency"
                placeholder="Select Currency"
                trackBy="value"
                labelKey="name"
                isRequired
              />
            </View>
            <View style={styles.formMargin}>
              <SociollaSelectBox
                label="Taxes Type"
                options={TAX_TYPES}
                name="taxes_type"
                placeholder="Select Taxes Type"
                trackBy="value"
                labelKey="name"
                isRequired
              />
            </View>
            <SociollaText style={styles.formMargin}>
              Effective Date
            </SociollaText>
            <View style={[styles.row, styles.formMargin, { width: '100%' }]}>
              <View style={{ flex: 1, marginRight: 10 }}>
                <SociollaDatePicker
                  label="Start Date"
                  name="from_date"
                  disableAfterDate={new Date(dateRange.to_date)}
                  disableBeforeDate={changeTimeZone(addDays(new Date(), -1))}
                  iconStyle={{
                    marginRight: 0,
                    marginLeft: isWeb ? -20 : isMobileWeb ? -40 : 0,
                  }}
                  isRequired
                  onChange={(value) => dateRangeHandler(value, 'from_date')}
                />
              </View>
              <View style={{ flex: 1 }}>
                <SociollaDatePicker
                  label="End Date"
                  name="to_date"
                  disableBeforeDate={new Date(dateRange.from_date)}
                  onChange={(value) => dateRangeHandler(value, 'to_date')}
                  iconStyle={{
                    marginRight: 0,
                    marginLeft: isWeb ? -20 : isMobileWeb ? -40 : 0,
                  }}
                  isRequired
                />
              </View>
            </View>

            <View style={styles.formMargin}>
              <SociollaCheckbox
                label="Use for default catalog price"
                name="is_default"
              />
            </View>

            <View style={styles.formMargin}>
              <SociollaCheckbox
                label="Price List for Consignment"
                name="is_consignment"
              />
            </View>
          </View>
          <View style={styles.flexWidth} />
        </>
      )}
      {!isAddMode && !isEditMode && !priceRules.loading && (
        <>
          <View style={styles.flexWidth}>
            <ItemDetail
              name="Status"
              value={data.status}
              valueStyle={data.statusStyle}
            />
            {data.status == 'Need Approval' && (
              <ItemDetail
                name="Waiting Approval"
                valueComponent={
                  <View style={{ flexDirection: 'column' }}>
                    {data.waiting_approvals?.length &&
                      data.waiting_approvals.map((u) => (
                        <User
                          name={u.name || ''}
                          image={u.image || ''}
                          key={'list-user-approval-' + u.id}
                          index={u.id}
                          style={{ paddingBottom: 10 }}
                        />
                      ))}
                  </View>
                }
              />
            )}
            <ItemDetail name="Description" value={data.description} />
            <ItemDetail
              name="Market Type"
              value={data.market_type?.code || ''}
            />
            <ItemDetail name="Currency" value={data.currency} />
            <ItemDetail
              name="Tax Types"
              value={
                data.taxes_type == 'inc'
                  ? 'Include Taxes'
                  : data.taxes_type == 'exc'
                  ? 'Exclude Taxes'
                  : '-'
              }
            />
            <ItemDetail name="Effective Date" value={data.effective_date} />
            <ItemDetail name="Last Update" value={data.last_updated} />
            <ItemDetail
              name="Is default catalog price"
              value={data.is_default ? 'Yes' : 'No'}
            />
            <ItemDetail
              name="Is used for consignment"
              value={data.is_consignment ? 'Yes' : 'No'}
            />
            <ItemDetail
              name="Is Active"
              value={data.is_active_auto ? 'Active' : 'In Active'}
              valueStyle={data.isActiveStyle}
            />
          </View>
          <View style={styles.flexWidth} />
        </>
      )}
      {!isAddMode && !isEditMode && priceRules.loading && (
        <View style={styles.loadingContainer}>
          <ActivityIndicator size="large" color={Colors.blue0} />
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  flexWidth: {
    flex: isWeb ? 1 : 0,
  },
  formContainer: {
    flexDirection: isWeb ? 'row' : 'column',
    width: '100%',
  },
  formMargin: {
    marginBottom: 15,
  },
  loadingContainer: {
    alignItems: 'center',
    marginVertical: 40,
    flex: 1,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});

export default PricelistDetail;
